import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  IconButton,
  Paper,
  Button
} from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import './Mensual.css';

const Mensual = ({ selectedDate, onDateChange }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [currentDate, setCurrentDate] = useState(new Date());
  const [loading, setLoading] = useState(false);

  // Nombres de los meses y días
  const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
                     "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                     const dayNames = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];  // Nuevo orden


  //traigo las citas por dia
  const fetchCitasDelDia = async (date) => {
    setLoading(true);
    try {
      const adjustedDate = new Date(date);
      adjustedDate.setMinutes(adjustedDate.getMinutes() - adjustedDate.getTimezoneOffset());
      const fecha = adjustedDate.toISOString().split('T')[0];
      
      const response = await fetch(`${apiUrl}/api/citas/completas?fecha=${fecha}`);
      
      if (!response.ok) throw new Error('Error al obtener citas');
      
      const citas = await response.json();
      console.log("Citas del día:", citas);
      
      // Validación y transformación de datos con la nueva estructura
      if (!Array.isArray(citas)) return [];
      
      return citas.map(cita => ({
        id_cita: cita.id_cita || 0,
        id_cliente: cita.cliente?.id || 0,
        fecha_hora: cita.fecha_hora || `${fecha} 00:00:00`,
        nombre_cliente: cita.cliente?.nombre || 'Sin nombre',
        apellidos_cliente: cita.cliente?.apellidos || '',
        telefono: cita.cliente?.telefono || null,
        tratamientos: cita.tratamientos || [], // Mantenemos el array completo de tratamientos
        tratamiento: cita.tratamientos?.[0]?.nombre || 'Tratamiento no especificado', // Primer tratamiento para compatibilidad
        precio: cita.precio_total?.toString() || "0.00", // Usamos precio_total de la nueva estructura
        duracion_total: cita.duracion_total || 0,
        id_empleado: cita.id_empleado || 0,
        id_puesto: cita.id_puesto || 0
      }));
      
    } catch (error) {
      console.error("Error fetching citas:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };


  // Cambiar mes
  const changeMonth = (offset) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + offset);
    setCurrentDate(newDate);
  };

  // Ir al mes actual
  const goToToday = async () => {
    const today = new Date();
    setCurrentDate(today);
    const citas = await fetchCitasDelDia(today);
    onDateChange(today, citas);
  };

  // Generar días del mes
  const generateDays = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    
    // Ajuste para que la semana empiece en Lunes (0=Dom, 1=Lun... 6=Sáb)
    const startDay = (firstDay.getDay() + 6) % 7; // Restamos 1 y manejamos Domingo (0 → 6)
    const daysInMonth = lastDay.getDate();
    
    const days = [];
    
    // Días vacíos al inicio (para alinear el primer día del mes con Lunes)
    for (let i = 0; i < startDay; i++) {
      days.push(null);
    }
    
    // Días del mes
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(i);
    }
    
    return days;
  };
  // Verificar si es el día actual
  const isCurrentDay = (day) => {
    const today = new Date();
    return (
      day &&
      currentDate.getMonth() === today.getMonth() &&
      currentDate.getFullYear() === today.getFullYear() &&
      day === today.getDate()
    );
  };

  // Verificar si es el día seleccionado
  const isSelectedDay = (day) => {
    return (
      day &&
      selectedDate.getDate() === day &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getFullYear() === currentDate.getFullYear()
    );
  };

  const handleDayClick = async (day) => {
    if (day) {
      const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
      onDateChange(newDate); // Solo actualiza la fecha, las citas son gestionadas por Principal
    }
  };
  
  return (
    <Box className="calendar-container">
      <Paper elevation={3} className="calendar-header">
        <IconButton onClick={() => changeMonth(-1)} className="nav-button">
          <ChevronLeft />
        </IconButton>
        
        <Typography variant="h5" className="month-title">
          {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </Typography>
        
        <IconButton onClick={() => changeMonth(1)} className="nav-button">
          <ChevronRight />
        </IconButton>
        
        <Button 
          variant="contained" 
          onClick={goToToday}
          className="today-button"
          disabled={loading}
        >
          {'Hoy'}
        </Button>
      </Paper>

      <div className="calendar-grid">
        {dayNames.map((day) => (
          <div key={day} className="day-header">
            {day}
          </div>
        ))}
        
        {generateDays().map((day, index) => (
          <div 
            key={index} 
            className={`day-cell 
              ${!day ? 'empty' : ''} 
              ${isCurrentDay(day) ? 'current-day' : ''}
              ${isSelectedDay(day) ? 'selected-day' : ''}`}
            onClick={() => !loading && handleDayClick(day)}
          >
            {day}
          </div>
        ))}
      </div>
    </Box>
  );
};

export default Mensual;